import { render, staticRenderFns } from "./AdminFoldersDialog.vue?vue&type=template&id=c3dce7fc&scoped=true"
import script from "./AdminFoldersDialog.vue?vue&type=script&lang=js"
export * from "./AdminFoldersDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminFoldersDialog.vue?vue&type=style&index=0&id=c3dce7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dce7fc",
  null
  
)

export default component.exports